import * as React from 'react';
import { Link } from 'react-router-dom';
import { Col, Panel } from 'react-bootstrap';
import { Translate } from '../../../../../../shared/LanguageService';
import { IOrder } from './Types';

interface IProps {
    order: IOrder;
}

let OrderDisplay = (props: IProps) => {
    return (
        <Col xs={6}>
            <Panel>
                <Panel.Heading>
                    <Panel.Title>
                        {Translate('order/plan/swap/order-compare/headers/orderNumber')}
                    </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                    <Link
                        to={`/orders/${props.order.id}/plan`}
                        title={Translate('order/plan/swap/order-compare/url')}
                        target="_blank"
                    >
                        {props.order.orderNumber}
                    </Link>
                </Panel.Body>
            </Panel>

            <Panel>
                <Panel.Heading>
                    <Panel.Title>
                        {Translate('order/plan/swap/order-compare/headers/address')}
                    </Panel.Title>
                </Panel.Heading>
                <Panel.Body>{props.order.address}</Panel.Body>
            </Panel>

            <Panel bsStyle={props.order.brokerAgent.same ? 'default' : 'warning'}>
                <Panel.Heading>
                    <Panel.Title>
                        {Translate('order/plan/swap/order-compare/headers/broker-agent')}
                    </Panel.Title>
                </Panel.Heading>
                <Panel.Body>{props.order.brokerAgent.value}</Panel.Body>
            </Panel>

            <Panel bsStyle={props.order.brokerFirm.same ? 'default' : 'warning'}>
                <Panel.Heading>
                    <Panel.Title>
                        {Translate('order/plan/swap/order-compare/headers/broker-firm')}
                    </Panel.Title>
                </Panel.Heading>
                <Panel.Body>{props.order.brokerFirm.value}</Panel.Body>
            </Panel>

            <Panel
                bsStyle={
                    !props.order.planEditor || props.order.planEditor.same ? 'default' : 'warning'
                }
            >
                <Panel.Heading>
                    <Panel.Title>
                        {Translate('order/plan/swap/order-compare/headers/plan-editor')}
                    </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                    {props.order.planEditor.value ? props.order.planEditor.value : ''}
                </Panel.Body>
            </Panel>

            <Panel
                bsStyle={!props.order.planFirm || props.order.planFirm.same ? 'default' : 'warning'}
            >
                <Panel.Heading>
                    <Panel.Title>
                        {Translate('order/plan/swap/order-compare/headers/plan-firm')}
                    </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                    {props.order.planFirm.value ? props.order.planFirm.value : ''}
                </Panel.Body>
            </Panel>
        </Col>
    );
};

export default OrderDisplay;
